import MockAdapter from 'axios-mock-adapter';
import { rulesMock2 } from '../../components/form/RulesMock';
import {
  mockStepCase1,
  mockStepCase2,
  mockStepCase3,
  mockStepCase4,
  mockStepCase5,
  multistepMock,
} from '../../components/form/StepMock';
import { SubmissionData, Submissions } from '../../models/submission/submission';
import { getFormByIdResponseModel, getFormsResponseModel, getFormTemplatesResponseModel } from './FormService';
import _ from 'lodash';
import { Discount } from '../../models/form/form';

export function formPublicMocks(mock: MockAdapter): void {
  // /api/organizations/00000000-0000-0000-0000-000000000000/forms
  mock
    .onGet(
      /\/api\/organizations\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/forms\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/discountcode\/[A-Z1-9]+/,
    )
    .reply((config) => {
      const code = _.last(config.url?.split('/'));
      let discount: Discount | null = null;

      if (code == 'WINTER10') {
        discount = { type: 'percent', value: 10, code };
      } else if (code == 'SUMMER15') {
        discount = { type: 'amount', value: 15, code };
      }

      return [200, discount];
    });

  mock
    .onGet(
      /\/api\/organizations\/[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}\/forms(\?.+)?$/,
    )
    .reply(() => {
      const result: getFormsResponseModel = [
        {
          id: '00000000-0000-0000-0000-000000000001',
          name: 'Mocked Registration Form1',
          recaptchaEnabled: true,
          status: 2,
          editedBy: {
            id: '00000000-0000-0000-0000-000000000000',
            firstName: 'Jonathan',
            name: 'Anctil',
            organizations: [],
          },
          submissionCount: 0,
          submissionLimit: 150,
          creationDate: new Date(2021, 0, 1).toString(),
          modificationDate: new Date(2021, 0, 31).toString(),
          organizationId: 'org-1',
          currency: 'cad',
          emailContent: null,
          discountCodes: null,
          hasDiscountCodes: false,
          localizations: [],
          fieldProperties: {},
          avatar: null,
        },
        {
          id: '00000000-0000-0000-0000-000000000002',
          name: 'Mocked Registration Form2',
          recaptchaEnabled: true,
          status: 4,
          editedBy: {
            id: '00000000-0000-0000-0000-000000000000',
            firstName: 'Jonathan',
            name: 'Anctil',
            organizations: [],
          },
          submissionCount: 0,
          submissionLimit: 150,
          creationDate: new Date(2021, 0, 1).toString(),
          modificationDate: new Date(2021, 0, 25).toString(),
          organizationId: 'org-1',
          currency: 'cad',
          emailContent: null,
          discountCodes: null,
          hasDiscountCodes: false,
          localizations: [],
          fieldProperties: {},
          avatar: null,
        },
        {
          id: '00000000-0000-0000-0000-000000000003',
          name: 'Mocked Registration Form3',
          recaptchaEnabled: true,
          status: 3,
          editedBy: {
            id: '00000000-0000-0000-0000-000000000000',
            firstName: 'Jonathan',
            name: 'Anctil',
            organizations: [],
          },
          submissionCount: 0,
          submissionLimit: 150,
          creationDate: new Date(2021, 0, 1).toString(),
          modificationDate: new Date(2021, 0, 27).toString(),
          organizationId: 'org-1',
          currency: 'cad',
          emailContent: null,
          discountCodes: null,
          hasDiscountCodes: false,
          localizations: [],
          fieldProperties: {},
          avatar: null,
        },
        {
          id: '00000000-0000-0000-0000-000000000004',
          name: 'Mocked Registration Form4',
          recaptchaEnabled: true,
          status: 4,
          editedBy: {
            id: '00000000-0000-0000-0000-000000000000',
            firstName: 'Jonathan',
            name: 'Anctil',
            organizations: [],
          },
          submissionCount: 75,
          submissionLimit: 100,
          creationDate: new Date(2021, 0, 1).toString(),
          modificationDate: new Date(2021, 0, 27).toString(),
          organizationId: 'org-1',
          currency: 'cad',
          emailContent: null,
          discountCodes: null,
          hasDiscountCodes: false,
          localizations: [],
          fieldProperties: {},
          avatar: null,
        },
        {
          id: '00000000-0000-0000-0000-000000000005',
          name: 'Mocked Registration Form5',
          recaptchaEnabled: true,
          status: 3,
          editedBy: {
            id: '00000000-0000-0000-0000-000000000000',
            firstName: 'Jonathan',
            name: 'Anctil',
            organizations: [],
          },
          submissionCount: 100,
          submissionLimit: 101,
          creationDate: new Date(2021, 0, 1).toString(),
          modificationDate: new Date(2021, 0, 13).toString(),
          organizationId: 'org-1',
          currency: 'cad',
          emailContent: null,
          discountCodes: null,
          hasDiscountCodes: false,
          localizations: [],
          fieldProperties: {},
          avatar: null,
        },
      ];
      return [200, result];
    });

  mock
    .onGet(
      /\/api\/organizations\/[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}\/forms\/([0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12})/,
    )
    .reply((requestConfig) => {
      const urlSections = requestConfig.url?.split('/') || [];
      const formId = urlSections[5];
      const formStep = {
        '00000000-0000-0000-0000-000000000001': [mockStepCase1],
        '00000000-0000-0000-0000-000000000002': [mockStepCase2],
        '00000000-0000-0000-0000-000000000003': multistepMock,
        '00000000-0000-0000-0000-000000000004': [mockStepCase3],
        '00000000-0000-0000-0000-000000000005': [mockStepCase4],
      };
      const formRules = {
        '00000000-0000-0000-0000-000000000001': [],
        '00000000-0000-0000-0000-000000000002': rulesMock2,
        '00000000-0000-0000-0000-000000000003': [],
        '00000000-0000-0000-0000-000000000004': [],
        '00000000-0000-0000-0000-000000000005': [],
      };
      const mockedForm: getFormByIdResponseModel = {
        id: formId,
        name: 'Mocked registration form',
        recaptchaEnabled: true,
        status: 2,
        editedBy: {
          id: '00000000-0000-0000-0000-000000000000',
          firstName: 'John',
          name: 'Doe',
          organizations: [],
        },
        creationDate: new Date(2021, 0, 1).toString(),
        modificationDate: new Date(2021, 0, 31).toString(),
        organizationId: '00000000-0000-0000-0000-000000000000',
        submissionCount: 0,
        submissionLimit: 1,
        paymentEnabled: true,
        paymentAccount: 'acct_1JfQ6NLga2tfp1m7',
        content: JSON.stringify({
          rules: formRules[formId] || [],
          steps: formStep[formId] || [],
        }),
        paymentModes: null,
        currency: 'usd',
        emailContent: null,
        discountCodes: null,
        hasDiscountCodes: false,
        localizations: [],
        fieldProperties: {},
        avatar: null,
      };

      return [200, mockedForm];
    });

  mock
    .onGet(/\/api\/organizations\/[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}\/templates/)
    .reply(() => {
      const result: getFormTemplatesResponseModel = [
        {
          id: 'blank',
          name: 'blank',
          content: `{"rules":[],"steps":[{"name":"Step1","sections":[{"name":"Section1","multiple":false,"visible":true,"fields":[]}]}]}`,
          paymentModes: null,
        },
        {
          id: 'contact',
          name: 'contact',
          content: `{"rules":[],"steps":[{"name":"Step1","sections":[{"name":"Section1","multiple":false,"visible":true,"fields":[{"size":12,"text":"Nom","hiddenText":false,"enabled":true,"visible":true,"required":true,"excludeFromReport":false,"maxLength":50,"type":"Text"},{"size":12,"text":"Courriel","hiddenText":false,"enabled":true,"visible":true,"required":false,"excludeFromReport":false,"maxLength":50,"type":"Text"},{"size":12,"text":"Téléphone","hiddenText":false,"enabled":true,"visible":true,"required":false,"excludeFromReport":false,"maxLength":50,"type":"Text"}]}]}]}`,
          paymentModes: null,
        },
      ];

      return [200, result];
    });

  mock
    .onGet(
      /\/api\/submissions\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/([0-9a-f]{7}-[0-9a-f]{8}-[0-9a-f]{8}-[0-9a-f]{9})/,
    )
    .reply(() => {
      const result: SubmissionData = {
        form: {
          id: '00000000-0000-0000-0000-000000000001',
          recaptchaEnabled: true,
          name: 'Mocked Registration Form1',
          status: 2,
          editedBy: {
            id: '00000000-0000-0000-0000-000000000000',
            firstName: 'Jonathan',
            name: 'Anctil',
            organizations: [],
          },
          submissionCount: 0,
          submissionLimit: 150,
          creationDate: new Date(2021, 0, 1).toString(),
          modificationDate: new Date(2021, 0, 31).toString(),
          content: {
            rules: [],
            steps: [mockStepCase3, mockStepCase4, mockStepCase5],
          },
          organizationId: 'org-1',
          currency: 'cad',
          emailContent: null,
          discountCodes: null,
          hasDiscountCodes: false,
          localizations: [],
          fieldProperties: {},
          avatar: null,
        },
        data: {
          '161fa424-5a17-4f44-b046-cc3ef2e2540-5': '666 Devil St',
          '161fa424-5a17-4f44-b046-cc3ef2e2540-6': 'Las Vegas',
          '161fa424-5a17-4f44-b046-cc3ef2e2540-7': 'MURICA',
          '161fa424-5a17-4f44-b046-cc3ef2e2540-8': 'The Big One',
          '161fa424-5a17-4f44-b046-cc3ef2e2540-9': 'donald@trump.com',
          '161fa424-5a17-4f44-b046-cc3ef2e2540-10': true,
          'multiple-id': [
            { firstname: 'A First Name', lastname: 'A last name' },
            { firstname: 'Joe', lastname: 'Sima' },
            { firstname: 'Much wow', lastname: 'So wow' },
          ],
        },
      };
      return [200, result];
    });

  mock.onGet(/\/api\/submissions\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/).reply(() => {
    const result: Submissions[] = [
      {
        id: '1234567-12325678-12345678-123456739',
        num: '3',
        firstName: 'Joel',
        lastName: 'Simard',
        email: 'joel@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12345678-123456789',
        num: '2',
        firstName: 'Sylvain',
        lastName: 'Gagnon',
        email: 'sylvain@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12345678-123456798',
        num: '1',
        firstName: 'Maxime',
        lastName: 'Sioui',
        email: 'maxime@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12345678-123456739',
        num: '3',
        firstName: 'Alex',
        lastName: 'Caissy',
        email: 'alexandre@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12345638-123456789',
        num: '2',
        firstName: 'Jean-Paul',
        lastName: 'II',
        email: 'jp-2@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12343678-123456798',
        num: '1',
        firstName: 'Louis',
        lastName: 'XIV',
        email: 'roi-soleil@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12345478-123456739',
        num: '3',
        firstName: 'Gustave',
        lastName: 'Fernandino',
        email: 'gustavio@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12545678-123456789',
        num: '2',
        firstName: 'Benjamin',
        lastName: 'Button',
        email: 'bb@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-16645678-123456798',
        num: '1',
        firstName: 'God',
        lastName: 'Zilla',
        email: 'crocrodile3000@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12377778-123456739',
        num: '3',
        firstName: 'Pere',
        lastName: 'Nowel',
        email: 'bonhomme-rouge@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12775678-123456789',
        num: '2',
        firstName: 'Bob',
        lastName: "L'éponge",
        email: 'spongypochette@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12345678-123666798',
        num: '1',
        firstName: 'Michael',
        lastName: 'Scott',
        email: 'michael@dundermifflinpapercompany.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12351678-123456739',
        num: '3',
        firstName: 'Jim',
        lastName: 'Halpert',
        email: 'jimmajimjim@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1222567-12345678-12345678-123456789',
        num: '2',
        firstName: 'Caillou',
        lastName: '',
        email: 'caillou@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234337-12345678-12345678-123456798',
        num: '1',
        firstName: 'Timothé',
        lastName: 'Noir',
        email: 'black-tea@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12344478-12345678-123456739',
        num: '3',
        firstName: 'Sydney',
        lastName: 'Crosby',
        email: 'crosby@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12345678-12225678-123456789',
        num: '2',
        firstName: 'Justin',
        lastName: 'Trudeau',
        email: 'jt@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
      {
        id: '1234567-12224678-12345678-123456798',
        num: '1',
        firstName: 'Paul',
        lastName: 'A Quebec',
        email: 'paul-a-quebec@kreezee.com',
        date: 'Mon Mar 01 2021 00:00:00 GMT-0500 (GMT-05:00)',
      },
    ];
    return [200, result];
  });
}
